import React from 'react';
import { injectIntl } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import Popout from 'components/Popout/Popout';
import Header from 'containers/Header/Header';
import SideNav from 'containers/SideNav/SideNavContainer';
import GetPermission from 'containers/GetPermission/GetPermissionContainer';
import Onboarding from 'containers/Onboarding/OnboardingContainer';
import { logger } from 'utils/logger';
import { isChrome } from 'utils/browser-utils';
import 'styles/core.module.scss';
import classes from './CoreLayout.module.scss';

logger.info(`Webapp version: ${process.env.REACT_APP_VERSION}`);

export class CoreLayout extends React.PureComponent {
  UNSAFE_componentWillMount() {
    if ((this.props.isDesktop) && this.props.firstTimeUser) {
      this.props.showOnboarding();
    }
  }

  render() {
    const {
      children,
      isFullScreenModalVisible,
      partialModal,
      isLoggedIn,
      onboardingAvailable,
      showPermissionPage
    } = this.props;

    if (onboardingAvailable && isLoggedIn) {
      return (
        <div>
          <Onboarding />
          {showPermissionPage && isChrome() ? <GetPermission /> : null}
        </div>
      );
    }

    return (
      <div>
        {showPermissionPage &&
          !onboardingAvailable && isChrome() ? <GetPermission /> : null}
        <div className={classes.vertFlexContainer}>
          <Header />
          <div
            className={isFullScreenModalVisible && !partialModal ?
              classes.horzFlexContainerBlur : classes.horzFlexContainer}
          >
            <SideNav />
            <div className={classes.mainContainer}>
              {children}
            </div>
          </div>
        </div>
        {this.props.isPopoutOpen && <Popout />}
      </div>
    );
  }
}

CoreLayout.propTypes = {
  addNotification: PT.func,
  browser: PT.object,
  children: PT.element.isRequired,
  firstTimeUser: PT.bool,
  ie11Enabled: PT.bool,
  intl: PT.object,
  isDesktop: PT.bool,
  isFullScreenModalVisible: PT.bool,
  isLoggedIn: PT.bool,
  isPopoutOpen: PT.bool,
  onboardingAvailable: PT.bool,
  partialModal: PT.bool,
  showOnboarding: PT.func,
  showPermissionPage: PT.bool
};

export default injectIntl(CoreLayout);
